'use client'

import { TCollectionFormatted } from '@/types/collection'
import { useFilterState } from './use-filter-state'

type Props = {
  collection: TCollectionFormatted
}

export const FilterInit: React.FC<Props> = ({ collection }) => {
  // Gọi hook để đồng bộ filter với URL ngay khi vào trang (mobile không cần mở Sheet)
  useFilterState({ collection })
  return null
}
